import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef, useState } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useCharacters } from '../../../contexts/Characters'
import { Roles } from '../../../utilities/constants'

const EditSeasonalRecord = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const characters = useCharacters()
    const formName = 'editSeasonalRecord'
    const { character, record } = modal.$state.data

    const editSeasonalRecordRef = useRef()
    editSeasonalRecordRef.current = () => {
        const formValues = form.$state.value
        const updatedRecord = character.seasonalRecords.find((oldRecord) => oldRecord._id === record._id)
        Object.assign(updatedRecord, formValues)

        koalition.put(`characters/${character._id}`, { seasonalRecords: character.seasonalRecords }).then((response) => {
            modal.close()
            toaster.success('Seasonal record updated successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => editSeasonalRecordRef.current(), controls: {
        merits: { validators: [Validators.required, Validators.integer, Validators.min(0)], value: record.merits },
        receivedFixedMges: { validators: [Validators.required, Validators.integer, Validators.min(0)], value: record.receivedFixedMges },
        penalties: { validators: [Validators.required, Validators.integer, Validators.min(0)], value: record.penalties },
        noShows: { validators: [Validators.required, Validators.integer, Validators.min(0)], value: record.noShows },
    } })

    useEffect(() => {
        modal.configure({ formName, submitLabel: 'Update' })
    }, [])

    return (
        <div className="row">
            {characters.authorized([Roles.developer, Roles.admin]) && (
                <div className="col-12 mb-3">
                    <Input type="number" control={form.$state.controls.merits} label="Merits" />
                </div>
            )}
            <div className="col-12 mb-3">
                <Input type="number" control={form.$state.controls.receivedFixedMges} label="Received Fixed MGEs" />
            </div>
            <div className="col-12 mb-3">
                <Input type="number" control={form.$state.controls.penalties} label="Penalties" />
            </div>
            <div className="col-12 mb-3">
                <Input type="number" control={form.$state.controls.noShows} label="No Shows" />
            </div>
        </div>
    )
}

export default EditSeasonalRecord